var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirbnbReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.airbnb-reviews{fill:url(#airbnb-reviews-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "airbnb-reviews-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbbab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30442,
    stopColor: "#ff6a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff385c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f2e50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "airbnb-reviews",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M38.95117,72.58252c-2.2168,0-4.33984-.77441-6.02539-1.98828-3.5127-2.52881-5.81934-7.46729-3.05762-12.80078l13.29297-26.15283c1.31543-2.58594,3.93359-4.19873,6.83301-4.20996h.03027c2.8877,0,5.50488,1.59082,6.83496,4.15771l-2.66406,1.37988c-.82324-1.58984-2.38184-2.5376-4.16992-2.5376h-.01953c-1.79688.00684-3.35547.96729-4.1709,2.56982l-13.29785,26.1626c-1.94434,3.75439-.32422,7.22168,2.1416,8.99658,2.46484,1.77539,6.2666,2.2124,9.20508-.81445l1.75293-1.83887,2.17188,2.07031-1.7627,1.84814c-2.18066,2.24756-4.69238,3.15771-7.09473,3.15771Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M61.0459,72.5835c-2.40039,0-4.9082-.90771-7.08203-3.14941l-1.77246-1.85742,2.17188-2.07031,1.7627,1.84814c2.9248,3.01562,6.73047,2.58105,9.19531.80518,2.46582-1.7749,4.08594-5.24219,2.14648-8.98633l-13.30273-26.17334c-.81543-1.60205-2.37402-2.5625-4.1709-2.56934h-.01953c-1.78809,0-3.34668.94727-4.16992,2.5376l-2.66406-1.37988c1.33008-2.56689,3.94727-4.15771,6.83496-4.15771h.03027c2.89941.01123,5.51758,1.62402,6.83301,4.20947l13.29785,26.16357c2.75684,5.32324.4502,10.26172-3.0625,12.79053-1.68555,1.21436-3.81152,1.98926-6.02832,1.98926Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M57.38123,49.39182l-4.07878-.8151-2.03563-3.62736c-.44481-.79247-1.58557-.79247-2.03029,0l-2.03563,3.62736-4.07878.8151c-.89115.17809-1.24371,1.26299-.62742,1.93088l2.82077,3.05689-.48528,4.13102c-.10602.90256.81691,1.57317,1.64252,1.19337l3.77892-1.73804,3.77901,1.73804c.82561.3798,1.74845-.2908,1.64243-1.19337l-.48519-4.13102,2.82077-3.05689c.61628-.66789.26373-1.75279-.62742-1.93088Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbnbReviewsScraper);
export default __webpack_public_path__ + "static/media/airbnb-reviews-scraper.1d120eeb3f779702e69ae306c9cc95b9.svg";
export { ForwardRef as ReactComponent };